import { apiGet, apiPost, apiPut, apiRequest } from '@/utils/request';
import { parsePaginatedResponseFull } from '@/utils/apiResponse';
import { DEFAULT_PAGE_SIZE } from '@/constants/api';
import type { MaterialImagePayload } from '@/types/materials';

export const materialsApi = {
  list: (params: Record<string, unknown> = {}) =>
    apiGet('/materials', { per_page: DEFAULT_PAGE_SIZE, page: 1, ...params }).then((d) =>
      parsePaginatedResponseFull(d, { page: 1, per_page: DEFAULT_PAGE_SIZE }),
    ),
  show: (id: number) => apiGet(`/materials/${id}`),
  create: (data: Record<string, unknown>) => apiPost('/materials', data),
  update: (id: number, data: Record<string, unknown>) => apiPut(`/materials/${id}`, data),
  delete: (id: number) => apiRequest(`/materials/${id}`, { method: 'DELETE' }),
  /**
   * 图片库批量新增（type=2）：一次最多 50 张，每张单独落一条素材记录。
   * name 留空时后端取 URL 里的文件名，仍为空则用「图片」兜底。
   */
  createImages: (images: MaterialImagePayload[]) => apiPost('/materials', { type: 2, images }),
  /** 批量删除：与单删同一个接口（软删），多个 id 用逗号拼在路径上 */
  batchDelete: (ids: number[]) => apiRequest(`/materials/${ids.join(',')}`, { method: 'DELETE' }),
};
